import axios from 'axios'

export const companiesAnalysisRanking = {
  namespaced: true,
  state: {
    data: [],
    meta: null,
    loading: false,
    loadError: false,
    message: null,
    filteredCount: 0,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
      state.loadError = false
    },
    exportCsv(state) {
      state.loading = true
      state.loadError = false
    },
    exportCsvSuccess(state) {
      state.loading = false
      state.loadError = false
    },
    exportCsvFailure(state) {
      state.loading = false
      state.loadError = true
    },
    readAnalysisRankingSuccess(state, payload) {
      state.data = payload.data.map(v => {
        return {
          id: v.id,
          type: v.type,
          scores: v.attributes.average_score,
          name: v.attributes.name,
          counts: v.attributes.posted_count,
        }
      })
      state.meta = {
        totalAverageScore: payload.meta.total_average_score,
        totalAveragePostedCount: payload.meta.total_average_posted_count,
        maxAverageScore: payload.meta.max_average_score,
        maxPostedCount: payload.meta.max_posted_count,
        minAverageScore: payload.meta.min_average_score,
        minPostedCount: payload.meta.min_posted_count,
        totalCount: payload.meta.total_count,
        totalPages: payload.meta.total_pages,
      }
      state.loading = false
      state.loadError = false
    },
    apiSuccess(state, message) {
      state.loading = false
      state.loadError = false
      state.message = message
    },
    apiFailure(state) {
      state.loading = false
      state.loadError = true
    },
    setValuesForFilter(state, payload) {
      state.filteredCount = payload.meta.total_count
    },
  },
  actions: {
    readAnalysisRanking({ commit }, { companyUuid, query }) {
      commit('apiConnect')
      return axios
        .post('/api/companies/' + companyUuid + '/analysis/rankings/reviews' + '.json', query)
        .then(res => {
          commit('readAnalysisRankingSuccess', res.data)
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    readAnalysisRankingForFilter({ commit }, { companyUuid, query }) {
      return axios
        .post('/api/companies/' + companyUuid + '/analysis/rankings/reviews' + '.json', query)
        .then(res => {
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    exportCsv({ state, commit }, { companyUuid, query }) {      
      if(state.loading) return false
      commit('exportCsv')
      return axios
        .post('/api/companies/' + companyUuid + '/export/analysis/rankings' + '.json', query)
        .then(() => {
          commit('exportCsvSuccess')
          return true
        })
        .catch(err => {
          commit('exportCsvFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
